import React from "react";
import SvgIcon from "../../../../../../parts/SvgIcon";

export const ActionsButtons = ({
  onAddSet,
  addSetImgSize,
  onRemoveSet,
  removeSetImgSize,
  addingSet,
  onSubmitSet,
  onDiscardSet,
  setIdx,
  extraCondition = true,
}) => {
  if (!addingSet.state && extraCondition)
    return (
      <td className={`actions`}>
        <button data-button-type="secondary" onClick={onAddSet}>
          <img
            src="/img/new-icons/add-gradient-icon.svg"
            height={addSetImgSize}
            width={addSetImgSize}
          />
        </button>
        <button data-button-type="secondary" onClick={onRemoveSet}>
          <img
            src="/img/new-icons/red-trash.svg"
            height={removeSetImgSize}
            width={removeSetImgSize}
          />
        </button>
      </td>
    );

  {
    /* These buttons will be shown only when the user is adding
                  a new set, and when this row is the new set */
  }
  if (addingSet.state && addingSet.index == setIdx)
    return (
      <td className="actions">
        <button data-button-type="primary" onClick={onSubmitSet}>
          <SvgIcon src="/img/new-icons/check.svg" noFilterOnLight />
        </button>
        <button data-button-type="secondary" onClick={onDiscardSet}>
          <SvgIcon src="/img/new-icons/red-cross-20px.svg" noFilterOnLight />
        </button>
      </td>
    );
  return null;
};
